import { render } from "./RequestAccess.vue?vue&type=template&id=5a766b92"
import script from "./RequestAccess.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./RequestAccess.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script